import { useEffect }       from "react";
import { useGetProfileId } from "_common/hooks/auth";
import { storeCacheId }    from "_common/utils/user";

const StoreCacheId = ( {
	isMobile,
	userId
} ) => {
	const _userId = useGetProfileId () || userId;

	useEffect ( () => {
		// This is for creating an storing a unique key for each logged in user
		// and same key for non logged in user.. which is used by CDN for caching
		// html response againt this key
		storeCacheId ( _userId, isMobile );
	}, [ _userId, isMobile ] );

	return null;
};

export default StoreCacheId;
